import React from 'react';

class QuestionProgress extends React.Component{

    render(){
        /*console.log(this.props.percentage);*/
        var percentage = this.props.percentage + 'px';
        return(
            <div id="QProgress">
                <div id="QBar" style={{width:percentage}}></div>
            </div>
        );
    }
}

export default QuestionProgress;

